import { render, staticRenderFns } from "./Topfive.vue?vue&type=template&id=72993530&"
import script from "./Topfive.vue?vue&type=script&lang=js&"
export * from "./Topfive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports